import { useDetailApi } from "../../../swr/useApi";
import { productService, productVariantsService } from "../../api_client";
import type { ProductDetailsDto, ProductVariantDto } from "../../../api";

export function useProductVariants(id: number) {
    return useDetailApi<ProductDetailsDto>({
        key: id ? `product-${id}` : null,
        serviceMethod: async () => await productService.getProductDetails(id),
    });
}

export function useProductVariantById(id: number) {
    return useDetailApi<ProductVariantDto>({
        key: id ? `product-variant-${id}` : null,
        serviceMethod: async () => await productVariantsService.getProductVariantById(id),
    });
}